import {h, Component} from 'preact';
import cx from 'classnames';

interface InquiryDetailsIconProps {
  icon?: string;
  label?: string;
  hasMargin?: boolean;
  fontSize?: number;
  color?: string;
};

interface InquiryDetailsIconState {};

export class InquiryDetailsIcon extends Component<InquiryDetailsIconProps, InquiryDetailsIconState> {


  getInquiryDetailsIcon(props: InquiryDetailsIconProps, state: InquiryDetailsIconState) {
    switch (props.icon) {
      // these will change depending on api's key name
      case 'flag':     return <i className="fas fa-fw fa-flag"></i>
      case 'bathroom': return <i className="fas fa-fw fa-shower"></i>
      case 'time':     return <i className="fas fa-fw fa-clock"></i>
      case 'floorarea': return <i className="fas fa-fw fa-expand"></i>
      case 'furnish':  return <i className="fas fa-fw fa-couch"></i>
      case 'swimming pool': return <i className="fas fa-fw fa-swimming-pool"></i>
      case 'garden':   return <i className="fas fa-fw fa-leaf"></i>
      case 'gym':      return <i className="fas fa-fw fa-dumbbell"></i>
      case 'pet friendly': return <i className="fas fa-fw fa-dog"></i>
      case 'receipts': return <i className="fas fa-fw fa-receipt"></i>
      case 'email':    return <i className="fas fa-fw fa-envelope"></i>
      case 'comment':  return <i className="fas fa-fw fa-comment"></i>
      case 'aircon':   return <i className="fas fa-fw fa-fan"></i>
      case 'cable tv': return <i className="fas fa-fw fa-tv"></i>
      case 'internet access': return <i className="fas fa-fw fa-wifi"></i>
      case 'security': return <i className="fas fa-fw fa-shield-alt"></i>
      case 'viber':    return <i className="fab fa-fw fa-viber"></i>
      case 'skype':    return <i className="fab fa-fw fa-skype"></i>
      case 'designation': return <i className="fas fa-fw fa-arrow-circle-right"></i>
      case 'companyname': return <i className="fas fa-fw fa-building"></i>

      case 'firstname':
      case 'lastname':
        return <i className="fas fa-fw fa-user"></i>

      case 'parking':
      case 'parking spaces':  
        return <i className="fas fa-fw fa-parking"></i>

      case 'location':
      case 'countryorigin':
        return <i className="fas fa-fw fa-map-pin"></i>

      case 'bedrooms': 
      case 'maid\'s room':
        return <i className="fas fa-fw fa-bed"></i>
      
      case 'mobile':
      case 'mobile':   
        return <i className="fas fa-fw fa-phone"></i>

      case 'budget':    
      case 'paymentterm':
        return <i className="fas fa-fw fa-money-bill"></i>
      
      case 'building': 
      case 'balcony':
      case 'type':
      case 'balcony/terrace':
        return <i className="far fa-fw fa-building"></i>

      default:
        return <i className={ `fas fa-fw ${props.icon}` } />;
    }
  }

  render(props: InquiryDetailsIconProps, state: InquiryDetailsIconState) {
    
    return (
      <div className="hi-inqdetails__ftf-icon">
        <p
          style={{
            fontSize: props.fontSize ? props.fontSize : '',
            color: props.color ? props.color : ''
          }} 
          className={ cx("hi-inqdetails__ftf-icon-fa", {
            'mr-0': !props.hasMargin }) }>
          { this.getInquiryDetailsIcon(props, state) }
        </p>
        <p className="hi-inqdetails__ftf-icon-label">{ props.label ? props.label : '' }</p>
      </div>
    )
  }

}